import { render } from "./NavBarMenu.vue?vue&type=template&id=c5e65f70"
import script from "./NavBarMenu.vue?vue&type=script&lang=js"
export * from "./NavBarMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/biriukov/Documents/Projects/generate-web-prices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__